module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance-management/finance-management-list/finance-management-list.component.scss
// module id = ./src/app/finance-management/finance-management-list/finance-management-list.component.scss
// module chunks = main